import { Component, OnInit } from "@angular/core";
import { NavController } from "@ionic/angular";
import { TaxService } from "src/app/services/tax/tax.service";
import { AlertComponent } from "src/app/shared/alert/alert.component";
import { JobService } from "src/app/services/jobs/job.service";
// import {
//   StripeCheckoutLoader,
//   StripeCheckoutHandler
// } from "ng-stripe-checkout";
import { PaymentService } from "src/app/services/payment/payment.service";
import { TransactionService } from "src/app/services/transaction/transaction.service";
import { LoaderService } from 'src/app/services/loader/loader.service';
import { UserService } from 'src/app/services/user/user.service';
import { AreaService } from 'src/app/services/Area/area.service';
import { ToastComponent } from 'src/app/shared/toast/toast.component';

declare var RazorpayCheckout:any;


@Component({
  selector: "app-cart-detail",
  templateUrl: "./cart-detail.page.html",
  styleUrls: ["./cart-detail.page.scss"]
})
export class CartDetailPage implements OnInit {
  jobData: any;
  discount: any;
  tax: any;
  dataFlag: boolean = false;
  total: any;
  amount: any;
  showAmount: any;
  currency:string="INR";
  razor_key:"rzp_live_a7i7PX5oyV6nnE"
  paymentAmount:number=999;
  paymentData:any;
  showLoad:boolean=false;
  userdata:any;
  totalPending:any=0;
  showPop:boolean=false;
  showLater:boolean=false;
  showPendingInfo:boolean=false;
  checkbox:boolean=false;
  onlyTotal:any;
  userDescription:any;
  pendingPayment:any;
  pendingJob:any;
  // private stripeCheckoutHandler: StripeCheckoutHandler;
  constructor(
    private navCtrl: NavController,
    private areaServic:AreaService,

    // private stripeCheckoutLoader: StripeCheckoutLoader,
    private taxService: TaxService,
    private alert: AlertComponent,
    private jobService: JobService,
    private paymentService:PaymentService,
    private transactionService:TransactionService,
    private loader:LoaderService,
    private userService:UserService,
    private toast:ToastComponent
  
  ) {}

  taxDetails() {
    this.taxService.getTaxDetails(this.jobData.plan.taxId).then(res => {
      console.log(res);
      this.jobData.tax = res;
      this.calculate();
    });
  }
  ionViewDidEnter() {
    this.areaServic.showHome=false
    
    this.userdata = JSON.parse(localStorage.getItem('userProfile'));
    this.lastPendingService();
    this.userService.getUserDetails(this.userdata.id).then((res)=>{
    this.userdata = JSON.parse(localStorage.getItem('userProfile'));
 
        // this.totalPending=this.totalPending.toFixed(2);

    })



    this.jobData = JSON.parse(localStorage.getItem("JobData"));
    console.log(this.jobData);
    this.dataFlag = false;
    console.log("hello");
    if (this.jobData.couponId && this.jobData.tax) {
      this.calculate();
    } else {
      this.taxDetails();
    }
  }

  lastPendingService(){
    let filter ={
      "where":{
        "userId":this.userdata.id
      },
      "limit":1,
      "order":"createdAt desc"
    }
    this.jobService.getAllJobs(filter).then((res:any)=>{
      console.log(res);
      if(res && res[0] &&res[0].serviceStatus == "Started" || res[0].serviceStatus == "UserNotPaid" ){
        console.log("not paid");
        this.pendingJob = res[0];
        this.pendingPayment = res[0].serviceStatus;
      }else{
        console.log("paid");
      }

    })
  }

  ngOnInit() {}

  ngAfterViewInit() {
    // this.stripeCheckoutLoader
    //   .createHandler({
    //     key: "pk_test_9c72H35Rzh1Nx8DkY70SKySf00BryCQ9da",
    //     token: token => {
    //       // Do something with the token...
    //       console.log("Payment successful!", token);
    //     }
    //   })
    //   .then((handler: StripeCheckoutHandler) => {
    //     this.stripeCheckoutHandler = handler;
    //   });
  }

  goback() {
    this.navCtrl.navigateBack("/address_multiple");
  }

  remove() {
    console.log("remove");
    localStorage.removeItem("JobData");
    this.navCtrl.navigateBack("/app/home");
  }

  sub() {
    if (this.jobData.multiple > 1) {
      this.jobData.multiple = this.jobData.multiple - 1;
      this.calculate();
    } else {
      if (this.jobData.multiple == 1) {
        this.alert
          .presentAlertConfirm("Are You sure You Want to Delete?")
          .then(res => {
            if (res["role"] == "cancel") {
              console.log("cancel");
            } else {
              this.remove();
            }
          });
      }
    }
  }
  add() {
    if (this.jobData.multiple < 10) {
      this.jobData.multiple = this.jobData.multiple + 1;
      this.calculate();
    }
  }

  calculate() {
    if (this.jobData.multiple) {
      this.amount = this.jobData.plan.cost * this.jobData.multiple;
    } else {
      this.amount = this.jobData.plan.cost;
    }
    this.showAmount =
      this.amount + (this.amount * this.jobData.tax.tax_percentage) / 100;

    if (this.jobData.couponId) {
      let dis = (this.amount * this.jobData.coupon.discount) / 100;
      if (dis > this.jobData.coupon.fix_amount) {
        this.discount = this.jobData.coupon.fix_amount;
        if(this.jobData.tax.fixType){
          this.tax = this.jobData.tax.fixAmount;
        }else{
          this.tax = ((this.amount - this.discount) * this.jobData.tax.tax_percentage) / 100;
        }
        this.total = this.amount - this.discount + this.tax;
      } else {
        this.discount = dis;
        if(this.jobData.tax.fixType){
          this.tax = this.jobData.tax.fixAmount;
        }else{
          this.tax = ((this.amount - this.discount) * this.jobData.tax.tax_percentage) / 100;
        }
        this.total = this.amount - this.discount + this.tax;
      }
      this.dataFlag = true;
    } else {
      this.dataFlag = true;
      this.discount = this.amount.toFixed(2);
      if(this.jobData.tax.fixType){
        this.tax = this.jobData.tax.fixAmount;
      }else{
        this.tax = (this.discount * this.jobData.tax.tax_percentage) / 100;
      }
      this.tax = this.tax.toFixed(2);
      this.total = parseFloat(this.amount) + parseFloat(this.tax);
      this.onlyTotal = parseFloat(this.amount) + parseFloat(this.tax)

      
    }
//     this.totalPending=0;
//     if(this.userdata.pendingService && this.userdata.pendingService.amount){
      
//       this.jobService.getJobDetailsAll(this.userdata.pendingService.jobId).then((res:any)=>{
//         if(res.pendingPayment && res.pendingPayment !="cash" && res.pendingPayment !="online" && 
//         (res.pendingPayment =="done" || res.pendingPayment =="later")){
// this.showPendingInfo=true;
// this.totalPending =parseFloat(this.totalPending) +parseFloat(this.userdata.pendingService.amount)
// console.log(this.userdata.pendingService.amount,"ppppppppending amount")
//       this.showPop=true;
//         }
//         console.log(this.totalPending,this.total,"asjdnaslfnsdkl")
//         this.total = parseFloat(this.total) + parseFloat(this.totalPending);
//       })

      
      
//           }
//           if(this.userdata.duePayment && this.userdata.duePayment.amount){
           
//             this.jobService.getJobDetailsAll(this.userdata.duePayment.jobId).then((res:any)=>{
//               if(res.pendingPayment && res.pendingPayment !="cash" && res.pendingPayment !="online" && 
//               (res.pendingPayment =="done" || res.pendingPayment =="later")){
//       this.showPendingInfo=true;
// console.log(this.userdata.duePayment.amount,"ppppppppending amount")

//       this.totalPending =parseFloat(this.totalPending)+ parseFloat(this.userdata.duePayment.amount)
//       this.showPop=true;
//               }
//               console.log(this.totalPending,this.total,"asjdnaslfnsdkl")
//               this.total = parseFloat(this.total) + parseFloat(this.totalPending);

//             })
      
//                 }

            
                // setTimeout(() => {
                
                // }, 1000);
                // this.totalPending=this.totalPending.toFixed(2);

    this.total = this.total.toFixed(2);

    // this.total +=(this.totalPending);

    // if(this.userdata.duePayment && this.userdata.duePayment.amount){
    //   this.total=parseFloat(this.total)+parseFloat(this.userdata.duePayment.amount);
    //   this.total = this.total.toFixed(2);

    // }
  }

  applyCoupon() {
    this.navCtrl.navigateForward("/coupons");
  }

  nextPage() {
    // this.stripeCheckoutHandler
    //   .open({
    //     amount: this.total * 100,
    //     currency: "EUR"
    //   })
    //   .then(token => {
    //     console.log("Payment successful!", token);
    //     this.callApi(token);
    //   })
    //   .catch(err => {
    //     if (err !== "stripe_closed") {
    //       throw err;
    //     }
    //   });
    this.payWithRazor();
    // let data={
    //   id:"123"
    // }
    // this.callApi(data);
  }
 
  nextPageLater(){
    
    // if(this.totalPending && this.totalPending !=0){
    //   console.log(this.totalPending)
    // console.log(this.showPop)
    //   this.showLater=true;
    // }else{

    if(this.pendingJob){
      this.toast.presentToastError("You have not paid the last job.Please pay for the last Job");
    }else{
      console.log(this.jobData);
      this.jobData.taxId = this.jobData.plan.taxId;
      this.jobData.priceTo = this.total;
      let job:any = JSON.parse(JSON.stringify(this.jobData));
      job.userData = job.user;
      job.planData = job.plan;
      job.couponData = job.coupon;
      job.addressData = job.address;
      job.serviceData = job.service;
      job.taxData = job.tax;
      job.pendingPayment="later";
      job.showAmount="partner"
      job.instruction = this.userDescription;
      delete job.coupon;
      delete job.plan;
      delete job.user;
      delete job.address;
      delete job.service;
      delete job.tax;
      delete job.CheckInTime;
      delete job.CheckOutTime;
      delete job.measureableUnit;
      delete job.dates;
  
  
  
      console.log(job);
      // this.loader.showLoading()
      this.jobService.addJob(job).then((res:any) => {
        // if(this.userdata.pendingService && this.userdata.pendingService.amount){
        //   let data={
        //     "jobId":res.id,
        //     "amount":this.total + this.userdata.pendinService.amount
        // }
      // this.userService.editUser({"pendingService":data},this.userdata.id).then((res)=>{
      //   this.navCtrl.navigateForward("/success-page");
  
      // })
  
      // }
      // else{
        let data={
          "jobId":res.id,
          "amount":parseFloat(this.total)
      }
      this.userService.editUser({"pendingService":data},this.userdata.id).then((res)=>{
        this.navCtrl.navigateForward("/success-page");
  
      })
      // }
    
      })
    // }
    }

  
  }

  callApi(stripeData) {
    this.loader.showLoading();

    console.log(this.jobData);
    this.jobData.taxId = this.jobData.plan.taxId;
    this.jobData.priceTo = this.onlyTotal;
    let job = JSON.parse(JSON.stringify(this.jobData));
    job.userData = job.user;
    job.planData = job.plan;
    job.couponData = job.coupon;
    job.addressData = job.address;
    job.serviceData = job.service;
    job.taxData = job.tax;
    delete job.coupon;
    delete job.plan;
    delete job.user;
    delete job.address;
    delete job.service;
    delete job.tax;
    delete job.CheckInTime;
    delete job.CheckOutTime;
    delete job.measureableUnit;
    delete job.dates;



    console.log(job);
    // this.loader.showLoading()
    this.jobService.addJob(job).then((res:any) => {
      console.log(res);
      let data ={ 
          "jobId":res.id,
          "Amount":this.onlyTotal,
          "vendorStatus":false,
          "userStatus":true,
          "vendorType":"",
          "userType":"RazorPay",
          "status":true
      }
      this.paymentService.addPayment(data).then((res:any)=>{
        console.log(res);
        let userdata = JSON.parse(localStorage.getItem('userProfile'));
        let transactionDetails = {
          "paymentId":res.id,
          "usertype":"user",
          "transactionId":stripeData,
          "amount":this.onlyTotal,
          "transactiontype":"RazorPay",
          "userId":userdata.id,
          "status":true,
          "transactionAssets":stripeData
        };
        this.transactionService.addTransaction(transactionDetails).then((res)=>{
          
          console.log(res);
          localStorage.removeItem("JobData");
          if(this.userdata.duePayment && this.userdata.duePayment.amount){
          this.userService.editUser({"duePayment":"","pendingService":""},this.userdata.id)
      
          }
          if(this.userdata.pendingService && this.userdata.pendingService.amount){

            this.jobService.editJob({"pendingPayment":""},this.userdata.pendingService.jobId)
          }
          

          this.navCtrl.navigateForward("/success-page");
        })
       
      })
    
    });
    this.loader.hideLoading()

  }


  removeCoupon(){
    delete this.jobData.couponId;
    delete this.jobData.couponData;
    localStorage.setItem('JobData',JSON.stringify(this.jobData));
    // this.jobData = JSON.parse(localStorage.getItem("JobData"));
    console.log(this.jobData);
    this.dataFlag = false;
    console.log("hello");
    if (this.jobData.couponId && this.jobData.tax) {
      this.calculate();
    } else {
      this.taxDetails();
    }
  }
 

  payWithRazor() {
    let self=this
    // self.loader.showLoading();
    let userdata = JSON.parse(localStorage.getItem('userProfile'));
    const options: any = {
      key:"rzp_test_RUV8qOpX3MjO3i",
            name:self.jobData.service.service_Name,
            description:self.jobData.service.service_Name,
            amount:(this.total*100).toFixed(2),
            image:  self.jobData.service.serviceBannerImage.url,
            currency:'INR',
            prefill:{
                      name:userdata.fullName,
                      email:userdata.email
                    },
      // order_id: id, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        "UserId":userdata.id
      },
      theme: {
        color:'#f68517'
      }
    };

    options.handler = ((response, error) => {
      options.response = response;
      console.log(response);
      self.callApi(response)
      console.log(options);
      // call your backend api to verify payment signature & capture transaction
    });
    options.modal.ondismiss = (() => {
    self.loader.hideLoading();

      // handle the case when user closes the form while transaction is in progress
      console.log('Transaction cancelled.');
      // alert('trasaction cancelled')
    });
    const rzp = new this.transactionService.nativeWindow.Razorpay(options);
    setTimeout(() => {
      rzp.open();
    }, 100);

//     var options = {
//       description: self.jobData.service.service_Name,
//       image: self.jobData.service.serviceBannerImage.url,
//       currency: "INR", // your 3 letter currency code
//       key: "rzp_test_RUV8qOpX3MjO3i", // your Key Id from Razorpay dashboard
//       amount: this.total*100, // Payment amount in smallest denomiation e.g. cents for USD
//       name: self.jobData.service.service_Name,
//       prefill: {
//         email: userdata.email,
//         contact: userdata.mobileNo,
//         name: userdata.fullName
//       },
//       theme: {
//         color: '#F37254'
//       },
//       modal: {
//         ondismiss: function () {
//           // alert('dismissed')
//           self.loader.hideLoading();
//         }
//       }
//     };
//     console.log(options)

//     var successCallback = function (payment_id) {
//       // alert('payment_id: ' + payment_id);
// // self.paymentData=payment_id
// console.log("working order")
// // self.showLoad=true;
// self.loader.showLoading();
// self.callApi(payment_id)
// // self.loader.hideLoading();

//     };

//     var cancelCallback = function (error) {
//       // alert(error.description + ' (Error ' + error.code + ')');
//       self.loader.hideLoading();
//     };
//     self.loader.showLoading();

//     RazorpayCheckout.open(options, successCallback, cancelCallback);
// // self.loader.hideLoading();

  }

  payOnlyPending() {
    let self=this
    // self.loader.showLoading();
    let userdata = JSON.parse(localStorage.getItem('userProfile'));
    const options: any = {
      key:"rzp_test_RUV8qOpX3MjO3i",
            name:"Fixit Now Service",
            description:"Due Payment",
            amount:((self.totalPending)*100).toFixed(2),
            image:  '/assets/img/icon.png',
            currency:'INR',
            prefill:{
                      name:userdata.fullName,
                      email:userdata.email
                    },
      // order_id: id, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        "UserId":userdata.id
      },
      theme: {
        color:'#f68517'
      }
    };

    options.handler = ((response, error) => {
      options.response = response;
      console.log(response);
      self.addPaymentOnly(response)

      console.log(options);
      // call your backend api to verify payment signature & capture transaction
    });
    options.modal.ondismiss = (() => {
    self.loader.hideLoading();

      // handle the case when user closes the form while transaction is in progress
      console.log('Transaction cancelled.');
      // alert('trasaction cancelled')
    });
    const rzp = new this.transactionService.nativeWindow.Razorpay(options);
    setTimeout(() => {
      rzp.open();
    }, 100);


  }

  addPaymentOnly(stripeData){
    let userdata = JSON.parse(localStorage.getItem('userProfile'));

    let data ={ 
      "jobId":userdata.id,
      "Amount":this.totalPending,
      "vendorStatus":true,
      "userStatus":true,
      "vendorType":"",
      "userType":"RazorPay",
      "status":true
  }
  this.paymentService.addPayment(data).then((res:any)=>{
    console.log(res);
    let transactionDetails = {
      "paymentId":res.id,
      "usertype":"user",
      "transactionId":stripeData,
      "amount":this.totalPending,
      "transactiontype":"RazorPay",
      "userId":userdata.id,
      "status":true,
      "transactionAssets":stripeData
    };
    this.transactionService.addTransaction(transactionDetails).then((res)=>{
      // this.userService.editUser({"duePayment":"","pendingService":""},userdata.id).then((res:any)=>{
        
        if(this.userdata.duePayment && this.userdata.duePayment.jobId){
          this.jobService.editJob({"pendingPayment":"online","showAmount":""},this.userdata.duePayment.jobId)
          if(this.userdata.pendingService && this.userdata.pendingService.jobId){
            this.jobService.editJob({"pendingPayment":"online","showAmount":""},this.userdata.pendingService.jobId)
            this.showPop=false;
            this.navCtrl.navigateForward(('/Cart-detail'))
          }else{
            this.showPop=false;
        this.navCtrl.navigateForward(('/Cart-detail'))
          }
        }
        
      // })
     
    })
  
  })
}

// checkboxChange(){
//   this.checkbox=!this.checkbox
// }
}
